import type { DataAction } from '../../../types/dataAction.type';

export const UPDATE_HAS_QR_CODE_LINK_DEFINE_STEP_VISITED = 'UPDATE_HAS_QR_CODE_LINK_DEFINE_STEP_VISITED' as const;

export const updateHasQrCodeLinkDefineStepVisited = (visited: boolean) => ({
  data: { visited },
  type: UPDATE_HAS_QR_CODE_LINK_DEFINE_STEP_VISITED,
});

export type UpdateHasQrCodeLinkDefineStepVisitedResponseAction = DataAction<
  typeof UPDATE_HAS_QR_CODE_LINK_DEFINE_STEP_VISITED,
  { visited: boolean }
>;
